import {
  FaFileAlt,
  FaPlay
} from 'react-icons/fa'
import {
  Icons,
  NavItemVerticalMini
} from '@eggplant/pattern-library'
import {
  MONITOR_AVAILABLITY,
  MONITOR_CONFIG,
  MONITOR_PERFORMANCE,
  MONITOR_RESULTS,
  RESULTS,
  RUNNER,
  renderLinkTo,
  routeLabels
} from '@eggplant/routing'
import { MonitorAvailablity, MonitorPerformance } from '@eggplant/pattern-library/src/lib/components/Icons/Icons'

interface Props {
  base: string
  isCollapsed: boolean
}

const MonitorNav = ({
  base,
  isCollapsed
}: Props) => (
  <>
    <NavItemVerticalMini
      icon={<MonitorAvailablity aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[MONITOR_AVAILABLITY]}
    >
      {renderLinkTo(base + '/' + MONITOR_AVAILABLITY)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<MonitorPerformance aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[MONITOR_PERFORMANCE]}
    >
      {renderLinkTo(base + '/' + MONITOR_PERFORMANCE)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<FaFileAlt aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[MONITOR_CONFIG]}
    >
      {renderLinkTo(base + '/' + MONITOR_CONFIG)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<FaPlay aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[RUNNER]}
    >
      {renderLinkTo(base + '/' + RUNNER)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<Icons.Results aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[MONITOR_RESULTS]}
    >
      {renderLinkTo(base + '/' + RESULTS)}
    </NavItemVerticalMini>
  </>
)

export default MonitorNav
